<template>
    <v-footer dark padless>
        <v-card-text class="white--text text-center" style="background-color: #1e1e1e; padding-top: 24px !important;">
            {{ $t('rodape.sigaRedes') }}<br><br>
            <v-btn
                v-for="social in socials"
                :key="social.type"
                class="mx-4 white--text"
                icon
                :href="social.link"
                target="_blank"
            >
                <v-icon size="24px">
                    {{ social.icon }}
                </v-icon>
            </v-btn>
        </v-card-text>

        <v-card flat tile class="white--text text-center"
            style="width: 100%; padding-top: 12px;">
            <v-card-text class="white--text pt-5">
                {{ configuracoes.slogan }}<br><br>
                <span v-if="!lojaNoBrasil">
                    {{ enderecoDaLojaEua }}
                </span>
                <span v-else-if="configuracoes.bairro != 0">
                    {{ configuracoes.bairro }} / {{ configuracoes.rua }}, {{ configuracoes.numero }}<br>
                    {{ configuracoes.municipio }} - {{ configuracoes.uf }}
                </span>
            </v-card-text>

            <v-card-text class="white--text">
                {{ new Date().getFullYear() }} — <strong>{{ configuracoes.fantasia }}</strong>
            </v-card-text>

            <v-divider/>

            <v-card-text v-if="configuracoes.permitir_anuncios" @click="goToLandingPage" class="white--text my-8">
                <div>
                    <i18n path="rodape.desenvolvidoPor" :tag="false"><template #empresa><b>Scheeren Company</b></template></i18n>
                </div>
                <div class="my-4">
                    <v-btn small>{{ $t('rodape.queroCriar') }}</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script>
import { mapState } from 'vuex';
import { isBrasil, telefoneInternacional } from '@/utils/paises';
import { linhaEnderecoEua } from '@/utils/enderecoFormato';

export default {
    name: 'Footer',

    data: () => ({
        socials: [],
    }),

    mounted() {
        this.setSocials();
    },

    computed: {
        ...mapState([
            'configuracoes',
        ]),

        lojaNoBrasil() {
            return isBrasil(this.configuracoes.pais);
        },

        // Fora do Brasil: "número rua, cidade, ESTADO ZIP".
        enderecoDaLojaEua() {
            return linhaEnderecoEua(this.configuracoes);
        },
    },

    watch: {
        configuracoes() {
            this.setSocials();
        },
    },

    methods: {
        setSocials() {
            this.socials = [];
            this.socials.push({type: 'facebook', icon: 'mdi-facebook', link: this.configuracoes.facebook});
            this.socials.push({type: 'instagram', icon: 'mdi-instagram', link: this.configuracoes.instagram});
            this.configuracoes.whatsapp && this.socials.push({
                type: 'whatsapp',
                icon: 'mdi-whatsapp',
                link: 'https://api.whatsapp.com/send?phone=' + telefoneInternacional(this.configuracoes.whatsapp, this.configuracoes.whatsapp_ddi)
            });
        },

        goToLandingPage() {
            window.open('https://use.zapermenu.com.br', 'blank');
        },
    },
}
</script>
